import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "./constants";

export function* getNavigationConfig({ getNavigationConfigApi }) {
  try {
    const result = yield call(getNavigationConfigApi);
    yield put({
      type: types.GET_NAVIGATION_CONFIG_SUCCESS,
      data: result?.data,
    });
  } catch (error) {
    yield put({
      type: types.GET_NAVIGATION_CONFIG_FAILURE,
      data: error
    });
  }
}

export function* watchGetNavigationConfig() {
  yield takeLatest(types.GET_NAVIGATION_CONFIG_REQUEST, getNavigationConfig);
}

export default [watchGetNavigationConfig];
